<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="编辑栏目"
      @ok="handleSubmit"
      :width="1000"
    >
      <a-form
        class="custom-compact-form"
        :form="form"
        :label-col="{ span: 3 }"
        :wrapper-col="{ span: 18 }"
        @submit="handleSubmit"
      >
        <a-form-item label="栏目名称">
          <a-input
            v-decorator="['name', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入栏目名称' },
                { max: 200, message: '最多200个字符' },
              ]
            }]"
            autocomplete="off"
          />
        </a-form-item>
        <a-form-item label="栏目内容">
          <wang-editor-frequently-asked-question
            v-decorator="['content', {
              rules: [
                { required: true, message: '请输入栏目内容' },
                { max: 2000, message: '最多2000个字符' },
              ]
            }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { updateVerticalScreenColumn } from '@/api/vertical_screen_column'
import WangEditorFrequentlyAskedQuestion from '@/components/Editor/WangEditor'

export default {
  name: 'EditVerticalScreenColumn',
  components: {
    WangEditorFrequentlyAskedQuestion
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    record: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'column_edit' }),
      submitting: false,
      data: {}
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.initFormData()
  },
  methods: {
    initFormData() {
      this.data = Object.assign({}, { name: this.record.name, content: this.record.content })
      this.$nextTick(() => {
        this.form.setFieldsValue(this.data)
      })
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          updateVerticalScreenColumn(this.record.id, values).then((res) => {
            if (res.code === 0) {
              // 关闭模态框
              this.isShow = false
              // 告知父组件已完成
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
